import { render, staticRenderFns } from "./btnWithConfirm.vue?vue&type=template&id=93e492ae"
import script from "./btnWithConfirm.vue?vue&type=script&lang=js"
export * from "./btnWithConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports